(function() {
  'use strict';

  function criarBotao() {
    const btn = document.createElement('button');
    btn.innerHTML = '💳 Pagar com Infinite Pay';
    btn.style.cssText = `
      display: block;
      width: 100%;
      padding: 15px;
      margin: 15px 0;
      background: linear-gradient(135deg, #2d5016 0%, #4a7c2c 100%);
      color: white;
      border: none;
      border-radius: 6px;
      font-size: 16px;
      font-weight: bold;
      cursor: pointer;
      font-family: 'Bree Serif', serif;
    `;

    btn.onclick = async function(e) {
      e.preventDefault();
      btn.disabled = true;
      btn.innerHTML = 'Processando...';

      try {
        const cart = await fetch('/cart.json').then(r => r.json());
        
        const dados = {
          handle: 'monenfant',
          items: cart.items.map(i => ({
            quantity: i.quantity,
            price: Math.round(i.price * 100),
            description: i.title
          })),
          order_nsu: 'MON-' + Date.now(),
          redirect_url: 'https://monenfant.com.br/obrigado',
          webhook_url: 'https://monenfant.com.br/webhook/infinitepay'
        };

        const res = await fetch('https://api.checkout.infinitepay.io/links', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(dados )
        });

        const data = await res.json();
        if (data.url || data.checkout_url) {
          window.location.href = data.url || data.checkout_url;
        } else {
          alert('Erro ao processar pagamento');
          btn.disabled = false;
          btn.innerHTML = '💳 Pagar com Infinite Pay';
        }
      } catch(e) {
        alert('Erro: ' + e.message);
        btn.disabled = false;
        btn.innerHTML = '💳 Pagar com Infinite Pay';
      }
    };

    return btn;
  }

  function injetar() {
    const checkout = document.querySelector('[name="checkout"]');
    if (checkout && !document.getElementById('infinitepay-btn')) {
      const btn = criarBotao();
      btn.id = 'infinitepay-btn';
      checkout.parentElement.insertBefore(btn, checkout);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injetar);
  } else {
    injetar();
  }

  setTimeout(injetar, 1000);
})();